export const OpenInNewTab = (url) => {
  if (!url || typeof url !== 'string') return;
  const formattedUrl = url.startsWith('http') ? url : `https://${url}`;
  window.open(formattedUrl, '_blank', 'noopener,noreferrer');
};
